export default __webpack_public_path__ + "static/media/somenew.23a79092.png";